import Vue from "vue";

import "./styles/quasar.styl";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import "@quasar/extras/ionicons-v4/ionicons-v4.css";
import "@quasar/extras/mdi-v3/mdi-v3.css";
import "@quasar/extras/eva-icons/eva-icons.css";
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QChip,
  QPageContainer,
  QPage,
  QPageSticky,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBtnDropdown,
  QIcon,
  QImg,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QAvatar,
  QScrollArea,
  QCard,
  QCardSection,
  QToggle,
  QTooltip,
  QRadio,
  QMarkupTable,
  QSeparator,
  QDialog,
  ClosePopup,
  QCardActions,
  QForm,
  QInput,
  Notify,
  Loading,
  QBreadcrumbs,
  QBreadcrumbsEl,
  GoBack, 
  QSelect,
  QBanner
} from "quasar";

Vue.use(Quasar, {
  config: {
    dark: false
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPage,
    QPageContainer,
    QPageSticky,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QChip,
    QBtnDropdown,
    QIcon,
    QImg,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QAvatar,
    QScrollArea,
    QCard,
    QCardSection,
    QToggle,
    QTooltip,
    QRadio,
    QMarkupTable,
    QSeparator,
    QDialog,
    QCardActions,
    QForm,
    QInput,
    Notify,
    Loading,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QSelect,
    QBanner
  },
  directives: {
    ClosePopup,
    GoBack
  },
  plugins: {
    Notify,
    Loading
  },
});
